import { responseErrorHandle } from '@/utils/utils';
import { 
  getConfigItemList,
  queryGovExpendEconomicClassify,
  queryDepExpendEconomicClassify,
  addConfigItem,
  editConfigItemInfo,
  changeConfigItemStatus,
  getItemTypeList,
  getConfigItemInfo,
  getItemTemplateCount,
  deleteConfigItemInfo
} from '../services/index';

const formatTree = (tree) => {
  if (tree.length) {
    tree?.forEach((item) => {
      item.label = item.name;
      item.value = item.code;
      if (item.children) formatTree(item.children);
    });
  }
};

export default {
  namespace: 'salaryProjectManage',
  state: {
    govExpendEconomicClassifyList: [],
    depExpendEconomicClassifyList: [],
    typeList: []
  },
  effects: {
    // 获取工资项目列表
    * getConfigItemList ({ payload }, { call }) {
      const res = yield call(getConfigItemList, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取政府经济科目列表
    * queryGovExpendEconomicClassify ({ payload }, { call, put }) {
      const res = yield call(queryGovExpendEconomicClassify);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          govExpendEconomicClassifyList: res?.result || [],
        },
      });
      return res;
    },

    // 获取部门经济科目列表
    * queryDepExpendEconomicClassify ({ payload }, { call, put }) {
      const res = yield call(queryDepExpendEconomicClassify, payload);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          depExpendEconomicClassifyList: res?.result || [],
        },
      });
      return res;
    },

    // 新增、编辑工资项目
    * addConfigItem ({ payload }, { call }) {
      const res = yield call(addConfigItem, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取工资项目被多少模版引用
    * getItemTemplateCount ({ payload }, { call }) {
      const res = yield call(getItemTemplateCount, payload);
      responseErrorHandle(res);
      return res;
    },
    // 删除工资项目
    * deleteConfigItemInfo ({ payload }, { call }) {
      const res = yield call(deleteConfigItemInfo, payload);
      responseErrorHandle(res);
      return res;
    },

    // 获取工资项目详情
    * getConfigItemInfo ({ payload }, { call }) {
      const res = yield call(getConfigItemInfo, payload);
      responseErrorHandle(res);
      return res;
    },

    // 新增、编辑工资项目
    * editConfigItemInfo ({ payload }, { call }) {
      const res = yield call(editConfigItemInfo, payload);
      responseErrorHandle(res);
      return res;
    },
    
    // 修改工资项目状态
    * changeConfigItemStatus ({ payload }, { call }) {
      const res = yield call(changeConfigItemStatus, payload);
      responseErrorHandle(res);
      return res;
    },
    
    // 获取项目类型列表
    * getItemTypeList ({ payload }, { call, put }) {
      const res = yield call(getItemTypeList);
      responseErrorHandle(res);

      yield put({
        type: 'update',
        payload: {
          typeList: res?.result || [],
        },
      });
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
